/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Interview_PrepInputs */

const en_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const de_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch-Vorbereitung`)
};

const fr_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'entretien`)
};

const es_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación de entrevista`)
};

const it_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione colloquio`)
};

const nl_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewvoorbereiding`)
};

const pl_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy`)
};

const fi_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelun valmistelu`)
};

const da_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse`)
};

const sv_pricing_compare_interview_prep = /** @type {(inputs: Pricing_Compare_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuförberedelse`)
};

/**
* | output |
* | --- |
* | "Interview prep" |
*
* @param {Pricing_Compare_Interview_PrepInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_interview_prep = /** @type {((inputs?: Pricing_Compare_Interview_PrepInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Interview_PrepInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_interview_prep(inputs)
	if (locale === "fr") return fr_pricing_compare_interview_prep(inputs)
	if (locale === "es") return es_pricing_compare_interview_prep(inputs)
	if (locale === "it") return it_pricing_compare_interview_prep(inputs)
	if (locale === "nl") return nl_pricing_compare_interview_prep(inputs)
	if (locale === "pl") return pl_pricing_compare_interview_prep(inputs)
	if (locale === "fi") return fi_pricing_compare_interview_prep(inputs)
	if (locale === "da") return da_pricing_compare_interview_prep(inputs)
	if (locale === "sv") return sv_pricing_compare_interview_prep(inputs)
	return en_pricing_compare_interview_prep(inputs)
});